import { useEffect } from "react";
import { api } from "@/lib/api";

const EVENTS = ["pointerdown", "touchstart", "keydown", "scroll", "wheel"];

// Solo manda ping si la app está visible y hubo interacción en los últimos 2 minutos.
export function useUsageHeartbeat() {
  useEffect(() => {
    let last = Date.now();
    const mark = () => { last = Date.now(); };
    EVENTS.forEach((e) => window.addEventListener(e, mark, { passive: true, capture: true }));
    const id = setInterval(() => {
      if (document.visibilityState === "visible" && Date.now() - last < 120000) api.post("/uso/ping").catch(() => {});
    }, 60000);
    return () => { clearInterval(id); EVENTS.forEach((e) => window.removeEventListener(e, mark, { capture: true })); };
  }, []);
}
